<script>
/**
 * @file 课程预约
 */

import {teacherCommonClasses, teacherCommonHistoryOrder} from '../../__mock__/classes';
import ForkissIcon from '../forkiss-icon';

export default {
    components: {
        ForkissIcon
    },
    filters: {
        classesType(value) {
            const obj = {
                postpartum: '产后',
                pregnancy: '孕期'
            };
            return obj[value];
        }
    },
    computed: {
        statusText() {
            return function (value) {
                switch (value) {
                    case 1:
                        return '预约';
                    case 2:
                        return '取消预约';
                    case 3:
                        return '已预约';
                    case 4:
                        return '申请候补';
                    case 5:
                        return '取消候补';
                    case 6:
                        return '候补中';
                    case 7:
                        return '候补成功';
                    default:
                        return '预约';
                }
            }
        },
        statusClass() {
            return function (value) {
                switch (value) {
                    case 6:
                        return 'status-waiting';
                    case 7:
                        return 'status-success';
                    default:
                        return 'status-todo';
                }
            }
        }
    },
    methods: {
        goto() {
            this.$router.push({name: 'teacher-private-classes'});
        },
        goback() {
            this.$router.push({
                name: 'teacher-home'
            });
        },
        handleTouchPlay() {
            let self = this;
            let moveX;
            let startX;
            let movebox = this.$refs.publicContainer;

            // 触摸开始
            function boxTouchStart(e) {
                let touch = e.touches[0];
                startX = touch.pageX;
            }

            function boxTouchMove(e) {
                let touch = e.touches[0];
                moveX = touch.pageX - startX;
            }

            function boxTouchEnd(e) {
                if (moveX > 0) { // 向右
                    self.$router.push({
                        name: 'teacher-private-classes'
                    });
                }

                if (moveX < 0) { // 向左

                }
            }

            // 滑动对象事件绑定
            movebox.addEventListener('touchstart', boxTouchStart, false);
            movebox.addEventListener('touchmove', boxTouchMove, false);
            movebox.addEventListener('touchend', boxTouchEnd, false);
        }

    },
    mounted() {
        this.$nextTick(function () {
            this.handleTouchPlay();
        });
    },
    data() {
        return {
            // 课程预约
            teacherCommonClasses: teacherCommonClasses,
            // 上课历史
            teacherCommonHistoryOrder: teacherCommonHistoryOrder
        };
    }
};
</script>

<template lang="pug">
.forkiss-public-order-container(ref="publicContainer")
    .tabs-wrapper
        .back-btn(@click="goback", data-touch="true")
        .tabs-box
            span.back-icon
            .tab-item.active
                span 普通课程
            .tab-item(@click="goto")
                span 私教课程
    .public-order-wrapper
        .order-classes-box(v-for="orderClass in teacherCommonClasses")
            .classes-img.status-success
            .classes-detail-box
                div
                    .class-type {{orderClass.type | classesType}}
                    .name {{orderClass.name}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.address}}
        .history-box-title 上课历史({{teacherCommonHistoryOrder.length}})
        .order-classes-box(v-for="orderClass in teacherCommonHistoryOrder")
            .classes-img.status-finish
            .classes-detail-box
                div
                    .class-type {{orderClass.type | classesType}}
                    .name {{orderClass.name}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.address}}
</template>

<style lang="less" scoped>
.forkiss-public-order-container {
    position: relative;
    font-size: .24rem;
    background: #f7f7f7;

    .tabs-wrapper {
        position: relative;

        .back-btn {
            position: absolute;
            z-index: 22;
            top: 50%;
            left: .28rem;
            transform: translateY(-50%);
            width: .2rem;
            height: .36rem;
            background-image: url(../../assets/back-black.png);
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    .tabs-box {
        display: flex;
        height: .88rem;
        line-height: .88rem;
        padding: 0 1rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        font-size: .28rem;
        background: #FFF;


        .tab-item {
            position: relative;
            flex: 1;
            color: #828d93;
            text-align: center;

            span {
                position: relative;
            }

            &.active {
                color: #a4805b;

                span::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: .02rem;
                    background: #a5805a;
                }
            }
        }
    }

    .public-order-wrapper {
        padding: .3rem;
    }

    .order-classes-box {
        position: relative;
        display: flex;
        height: 2.3rem;
        margin-bottom: .3rem;
        box-shadow: 0 .13rem .13rem 0 rgba(4, 26, 55, 0.07);
        background: #FFF;

        * {
            pointer-events: none;
        }

        .classes-img {
            width: 3.12rem;
            height: 100%;
            background: #f0dbca;
            background-image: url(../../assets/order-bg1.png);
            background-size: cover;
            background-position: center;

            &.status-waiting,
            &.status-finish {
                opacity: .6;
            }
        }
        .classes-detail-box {
            position: relative;
            padding-left: .45rem;
            flex: 1;
            display: flex;
            align-items: center;


            .status-waiting {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .5rem;
                background: #ffc68b;
                color: #FFF;
                font-size: .24rem;
            }
            .status-success {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .5rem;
                background: #b0de95;
                color: #FFF;
                font-size: .24rem;
            }
            .class-type {
                color: #999;
                font-size: .2rem;
            }
            .name {
                font-size: .28rem;
                color: #a4805b;
            }
            .time {
                color: #999;
            }
            .address {
                color: #999;
            }
        }
    }

    .history-box-title {
        text-align: center;
        color: #999;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: .24rem;

        &::before {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-right: .15rem;
            vertical-align: super;
        }

        &::after {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-left: .15rem;
            vertical-align: super;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/common-classes.vue